import * as Highcharts from 'highcharts';
import { PRIMARY_COLOR } from 'src/colors';

export const CHART_LABEL_COLOR = '#777'
export const CHART_TEXT_COLOR = '#333'

export const CommonChartConfig = {
    yAxis: (title: string): Highcharts.YAxisOptions => ({
        title: { 
            text: title, 
            style: { fontSize: '1em', color: CHART_LABEL_COLOR } 
        },
        labels: { 
            style: { color: CHART_LABEL_COLOR } 
        },
        tickAmount: 8,
        opposite: false,
    }),
    
    legend: (): Highcharts.LegendOptions => ({
    enabled: true,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom',
    itemStyle: { fontSize: '12px', color: CHART_TEXT_COLOR },
    symbolHeight: 12,
    symbolWidth: 30,
    symbolRadius: 20,
}),

/**
 * Common Scrollbar configuration
 * @param scrollbarEnable - enable/disable scrollbar
*/
scrollbar: (
    scrollbarEnable: boolean,
    color: string = PRIMARY_COLOR
): Highcharts.ScrollbarOptions => ({
    enabled: scrollbarEnable,
    liveRedraw: false,
    showFull: false,
    barBackgroundColor: color,
}),

plotOptions: (navigatorEnable: boolean): Highcharts.PlotOptions => ({
    series: { showInNavigator: navigatorEnable},
    column: {
        showInNavigator: true,
        stacking: 'normal',
      grouping: false,
      dataGrouping: {
          enabled: false,
        },
    },
}),
};

